import React from 'react';
import {Helmet} from "react-helmet";

class ViewKeyWords extends React.Component {

    constructor(props) {
        super(props)
    }

    render() {

        let keywords = (
            <Helmet>
            <meta name="keywords" id="keywordsMeta"
                  content={this.props.systemConfig.systemKeywords}/>
            </Helmet>
        );
        return keywords
    }

}

export default ViewKeyWords;
